import { takeLatest, put, call } from "redux-saga/effects"
import axios from "axios"
import {
  createRequestPromise,
  getCurrentDateTimeInSeconds,
} from "utils/request-helper"

const LOGIN_START = "LOGIN_START"
const LOGIN_SUCCESS = "LOGIN_SUCCESS"
const LOGIN_FAILURE = "LOGIN_FAILURE"
const LOGOUT = "LOGOUT"

const GET_CURRENT_USER_START = "GET_CURRENT_USER_START"
const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS"
const GET_CURRENT_USER_FAILURE = "GET_CURRENT_USER_FAILURE"

const initialState = {
  id: "0",
  accessToken: undefined,
  expiresIn: undefined,
  expirationSeconds: undefined,
  loggedIn: false,
  loading: false,
  error: false,
  currentUser: undefined,
  selectedUser: undefined,
}

// Reducer

export default function reducer(state = initialState, action) {
  const { payload } = action

  switch (action.type) {
    case LOGIN_START:
      return Object.assign({}, state, {
        loading: true,
      })

    case LOGIN_SUCCESS: {
      saveToLocal([
        { key: "accessToken", value: payload.access_token },
        { key: "expiresIn", value: payload.expires_in },
        {
          key: "expirationSeconds",
          value:
            parseInt(payload.expires_in, 10) + getCurrentDateTimeInSeconds(),
        },
      ])

      return Object.assign({}, state, {
        accessToken: payload.access_token,
        expiresIn: payload.expires_in,
        expirationSeconds:
          parseInt(payload.expires_in, 10) + getCurrentDateTimeInSeconds(),
        loading: false,
        loggedIn: true,
        error: false,
      })
    }

    case LOGIN_FAILURE: {
      purgeLocal()

      return Object.assign({}, state, {
        loading: false,
        loggedIn: false,
        error: true,
      })
    }

    case LOGOUT: {
      purgeLocal()

      return Object.assign({}, state, {
        accessToken: undefined,
        expiresIn: undefined,
        expirationSeconds: undefined,
        loading: false,
        loggedIn: false,
        error: false,
        currentUser: undefined,
      })
    }

    case GET_CURRENT_USER_START:
      // TODO
      return state

    case GET_CURRENT_USER_SUCCESS: {
      const { data: { id, attributes }, included } = payload

      let currentUser = {
        id: id,
        email: attributes["email"],
        firstName: attributes["first-name"],
        lastName: attributes["last-name"],
        role: attributes["role"],
        createdAt: attributes["created-at"],
        updatedAt: attributes["updated-at"],
      }

      if (currentUser.role === "staff") {
        currentUser.camp =
          included && included.find(item => item.type === "camps")
      }

      // For eventual OpBeat installation
      // setUserContext({
      //   id,
      //   name: attributes["first-name"] + " " + attributes["last-name"],
      //   type: attributes["user-type"],
      // })

      return Object.assign({}, state, { currentUser })
    }

    case GET_CURRENT_USER_FAILURE:
      // TODO
      return state

    default:
      return state
  }
}

// Utility methods

function saveToLocal(items) {
  items.forEach(({ key, value }) => localStorage.setItem(key, value))
}

function removeFromLocal(items) {
  items.forEach(({ key, value }) => localStorage.removeItem(key))
}

function purgeLocal() {
  removeFromLocal([
    { key: "accessToken", value: undefined },
    { key: "expiresIn", value: undefined },
    { key: "expirationSeconds", value: undefined },
  ])
}

// Actions

export function getCurrentUser() {
  return { type: GET_CURRENT_USER_START }
}

export function login(email, password) {
  return {
    type: LOGIN_START,
    payload: { email, password },
  }
}

export function forceLogin(access_token, expires_in) {
  return { type: LOGIN_SUCCESS, payload: { access_token, expires_in } }
}

export function logout() {
  return { type: LOGOUT }
}

// Fetch/Call methods for sagas

function postLogin(email, password) {
  return axios({
    method: "POST",
    url: `${process.env.REACT_APP_API_URL}/api/oauth/token`,
    data: {
      grant_type: "password",
      username: email,
      password: password,
      scope: "campsandcampers",
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  }).then(response => {
    return response
  })
}

function fetchCurrentUser() {
  return createRequestPromise({ method: "GET", route: "me?include=camp" })
}

// Sagas

function* loginStart(action) {
  const { email, password } = action.payload

  try {
    const response = yield call(postLogin, email, password)
    yield put({ type: LOGIN_SUCCESS, payload: response.data })
  } catch (error) {
    yield put({ type: LOGIN_FAILURE, payload: { error } })
  }
}

function* getCurrentUserStart(action) {
  try {
    const response = yield call(fetchCurrentUser)

    yield put({
      type: GET_CURRENT_USER_SUCCESS,
      payload: response.data,
    })
  } catch (error) {
    yield put({ type: LOGIN_FAILURE, payload: { error } })
  }
}

// Parant Saga

export function* loginSaga() {
  yield takeLatest(GET_CURRENT_USER_START, getCurrentUserStart)
  yield takeLatest(LOGIN_START, loginStart)
}



// WEBPACK FOOTER //
// ./src/redux/ducks/User.js